export default __webpack_public_path__ + "static/media/javascript.1776ef3b.gif";